export const PODCAST_SUPPORT_EMAIL = 'podcaster-support@spotify.com';
export const DEFAULT_SPOTIFY_AGGREGATOR_ID = '6BJtNPLQSTx541yBr7HDFq';

export const CATEGORIES_KEY = 'categoriesState';
export const COUNTRIES_KEY = 'countriesState';
export const LANGUAGES_KEY = 'languagesState';
export const AGGREGATORS_KEY = 'aggregatorsState';

export const CURRENT_SPEC_PDF = `${window.location.origin}/terms/Spotify_Podcast_Delivery_Specification_v1.6.pdf`;
